import api from "@/api/api";
import message, { MessageDTO } from "@/model/message";
import PaginateModel, {PaginateDTO} from "@/model/paginate";
import Message from "@/model/message";

interface messageList {
  list: message[],
  paginate: PaginateDTO
}

interface messageListResponse {
  meta: {
    status: number,
    message: string
  },
  data: {
    data: MessageDTO[];
    pagination: any;
  }
}

export class messageApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async list(query = {}):Promise<messageList> {
    const response = await this.getHttp().get<messageListResponse>('messages', {
      params: query,
      data: {
        notLoading: true
      }
    });

    if (response.status != 200) {
      return;
    }
    const list = response.data.data.data.map((item) => {
      return new Message(item);
    });
    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });

    return {
      list,
      paginate
    };
  }

  async getMessages(query = {}): Promise<Message[]> {
    const response = await this.getHttp().get<any>("/messages/without-paginate", {
      params: query,
    });
    if (response.status === 200) {
      return response.data.data.map((item) => new Message(item));
    }
  }

  async sendMessage(data):Promise<any> {
    data.notLoading = true;
    await this.getHttp().post('messages', data)
  }

  async readMessage(data):Promise<any> {
    await this.getHttp().patch('messages', data)
  }

  async getSocketUrl():Promise<any> {
    const response = await this.getHttp().get('socket-url', { data: { notLoading: true } });

    if (response.status === 200) {
      return response.data.data.link;
    }
  }
}

export default new messageApi;